import { useEffect } from 'react'

export const PIXEL_ID = '1009578682058738'

type FbqArgs = [string, string, Record<string, unknown>?]

interface FbqFunction {
  (...args: FbqArgs): void
  callMethod?: (...args: FbqArgs) => void
  queue: FbqArgs[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

const SCRIPT_ID = 'meta-pixel-script'

function bootstrapPixel(): void {
  if (window.fbq) return

  const fbq = function (...args: FbqArgs) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue.push(args)
    }
  } as FbqFunction

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}

export function useMetaPixel(): void {
  useEffect(() => {
    bootstrapPixel()
    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')
  }, [])
}
